import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { s as styleInject } from '../style-inject.es-e7b07dd7.js';
import { NEW_PAIR_BUTTON } from '../dataHooks.js';
import PlusIcon from '../icons/PlusIcon.js';

var css_248z = ".NNnVR{align-items:center;background:transparent;border:none;cursor:pointer;display:flex;min-height:48px;padding:0;position:relative;width:max-content}.NNnVR:hover{opacity:.5}.C2aeD{display:flex;padding-inline-start:10px}.C2aeD,.C2aeD svg{color:var(--ricos-action-color,#116dff)}.C2aeD svg{fill:var(--ricos-action-color,#116dff)}.Kd2vo{cursor:pointer;font-size:16px;font-stretch:normal;font-style:normal;font-weight:400;letter-spacing:normal;padding-inline-start:8px}";
var styles = {"new_pair_container":"NNnVR","new_pair_button":"C2aeD","new_pair_label":"Kd2vo"};
styleInject(css_248z);

function NewPairButton({
  label,
  onClick
}) {
  const { tabIndex } = useContext(RicosContext);
  return (
    //using 'div' element instead of 'button' to fix a bug of focus on element in Firefox in OSX
    // further reading, https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus#Clicking_and_focus
    /* @__PURE__ */ React.createElement(
      "div",
      {
        role: "button",
        tabIndex,
        className: styles.new_pair_container,
        onClick,
        onKeyPress: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            onClick(e);
          }
        },
        onMouseDown: (e) => {
          e.preventDefault();
          e.stopPropagation();
        },
        "data-hook": NEW_PAIR_BUTTON
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.new_pair_button }, /* @__PURE__ */ React.createElement(PlusIcon, null), /* @__PURE__ */ React.createElement("label", { className: styles.new_pair_label }, label))
    )
  );
}
NewPairButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export { NewPairButton as default };
//# sourceMappingURL=NewPairButton.js.map
